import { render, staticRenderFns } from "./FieldsManagement.vue?vue&type=template&id=5a3ac80e&"
import script from "./FieldsManagement.vue?vue&type=script&lang=js&"
export * from "./FieldsManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports